import React from 'react';

import NativeCheckBox from '@react-native-community/checkbox';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { useTheme } from '../Themes';

import styles from './CheckBox.Styles';

const CheckBox = ({ style, ...props }) => {
  const theme = useTheme();
  const backgroundColor = theme?.colors?.checkBox?.background;
  const markColor = theme?.colors?.checkBox?.mark;
  const borderColor = theme?.colors?.borderColorFive;

  return (
    <NativeCheckBox
      boxType="square"
      style={[styles.container, style]}
      onAnimationType="bounce"
      offAnimationType="bounce"
      onFillColor={backgroundColor}
      onTintColor={backgroundColor}
      onCheckColor={markColor}
      tintColors={{ true: backgroundColor, false: borderColor }}
      tintColor={borderColor}
      animationDuration={0}
      {...props}
      testID={FoundationTestKeys.nativeCheckBox}
    />
  );
};

CheckBox.propTypes = {
  style: ViewPropTypes.style,
  props: PropTypes.object,
};

export default CheckBox;
